import React, { useEffect, useState, useContext, useRef } from 'react';
import Fetch from '@/utils/Fetch';
import Time from '@/utils/time';
import Helper from '@/utils/helper';

const isTimerRunning = function (timers: any) {
    return getRunningTimers(timers).length > 0;
};

const getRunningTimers = function (timers: any) {
    let running = timers.filter((timer: any) => {
        return timer.EndTime === null || timer.EndTime === undefined;
    });

    return running;
};

const stopTimer = async (timers: any, employeeID: any) => {
    
    let applicableTimers = timers.filter((x: any) => x.EndTime === null && x.EmployeeID === employeeID);
    if (applicableTimers.length === 0) {
        return;
    }

    let timer = applicableTimers[0];
    let now = Time.now();
    timer.EndTime = Time.toISOString(now);

    const result = await Fetch.put({
        url: "/JobTime",
        params: timer
    });

    //timerContext.updateRunningTimers();
    return result;
};

// Starts a timer on the job for the employee. Only one timer can run at a time, so this returns
// { started: false } without starting anything when the employee already has one running.
const startJobTimer = async (jobCardID: string, employeeID: string, userName: string) => {
    const running = await Fetch.get({
        url: "/JobTime/RunningTimers",
        params: {}
    });

    if ((running?.Results ?? []).length > 0) {
        return { started: false };
    }

    const now = Time.now();
    const result = await Fetch.post({
        url: "/JobTime",
        params: {
            JobCardID: jobCardID,
            EmployeeID: employeeID,
            StartTime: Time.toISOString(now),
            EndTime: null,
            IsTime: true,
            Billable: false,
            Overtime: false,
            SLAtime: false,
            ID: Helper.emptyGuid(),
            IsActive: true,
            CreatedBy: userName,
            CreatedDate: Time.toISOString(now),
            ModifiedBy: userName,
            ModifiedDate: Time.toISOString(now),
        }
    });

    return { started: !!result?.ID };
};

export default {
    isTimerRunning,
    getRunningTimers,
    stopTimer,
    startJobTimer,
};
